import { TableColumn } from "../../../../components/ModularDataTable";
import { i18n } from "../../../../translate/i18n";

export const createColumns = ({ isWholeSaler }: any): TableColumn[] => {
    const columns: TableColumn[] = [
        { key: i18n.t(`customer_list.name`), value: 'name', type: 'text', sortable: true },
        { key: 'CPF/CNPJ', value: 'doc', type: 'text', sortable: true }, // Add a coluna de CPF ou CNPJ para toodos
        { key: 'Email', value: 'email', type: 'text', sortable: true },
        { key: i18n.t(`customer_list.phone`), value: 'phone', type: 'text' },
        { key: i18n.t(`customer_list.date`), value: 'created', type: 'datetime', sortable: true },
    ]

    if (isWholeSaler) {
        columns.push({
            key: 'Grupo',
            value: 'group',
            type: 'custom',
            render: (value: string) => {
                return (<span className='badge badge-light flex justify-content-center align-items-center'>{value}</span>)
            },
        })
        columns.push({
            key: 'Status',
            value: 'status',
            type: 'custom',
            render: (value: 'Ativo' | 'Inativo' | 'Bloqueado' | 'Pendente' | 'Não informado') => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <span
                            className={`badge ${value === 'Ativo'
                                    ? 'badge-success'
                                    : value === 'Inativo'
                                        ? 'badge-secondary'
                                        : value === 'Bloqueado'
                                            ? 'badge-danger'
                                            : value === 'Pendente'
                                                ? 'badge-warning'
                                                : 'badge-light'
                                } flex justify-content-center align-items-center`}
                        >
                            {value}
                        </span>
                    </div>
                )
            },
        })
    }


    return columns
}